export default __webpack_public_path__ + "static/Plain-Regular-8014f889ce6e99588740b1df59acbb38.woff2";